import api from './api';

export const custodianRolesAPI = {
  // Get all available permissions
  getAvailablePermissions: async () => {
    const response = await api.get('/api/custodian-roles/permissions');
    return response.data;
  },

  // Get role statistics
  getRoleStats: async () => {
    const response = await api.get('/api/custodian-roles/stats');
    return response.data;
  },

  // Get all roles for the current custodian
  getRoles: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await api.get(`/api/custodian-roles?${params.toString()}`);
    return response.data;
  },

  // Create a new role
  createRole: async (roleData) => {
    const response = await api.post('/api/custodian-roles', roleData);
    return response.data;
  },

  // Get a specific role by ID
  getRoleById: async (roleId) => {
    const response = await api.get(`/api/custodian-roles/${roleId}`);
    return response.data;
  },

  // Update a role
  updateRole: async (roleId, updateData) => {
    const response = await api.put(`/api/custodian-roles/${roleId}`, updateData);
    return response.data;
  },

  // Delete a role
  deleteRole: async (roleId) => {
    const response = await api.delete(`/api/custodian-roles/${roleId}`);
    return response.data;
  },

  // Assign role to sub-account
  assignRoleToSubAccount: async (roleId, subAccountId) => {
    const response = await api.post('/api/custodian-roles/assign', {
      roleId,
      subAccountId
    });
    return response.data;
  },

  // Remove role from sub-account
  removeRoleFromSubAccount: async (subAccountId) => {
    const response = await api.delete(`/api/custodian-roles/assign/${subAccountId}`);
    return response.data;
  },

  // Get pending role approval requests
  getPendingRoleApprovals: async () => {
    const response = await api.get('/api/custodian-roles/pending-approvals');
    return response.data;
  },

  // Get role approval history
  getRoleApprovalHistory: async () => {
    const response = await api.get('/api/custodian-roles/approval-history');
    return response.data;
  },

  // Approve role creation request (using general approval API)
  approveRole: async (requestId) => {
    const response = await api.put(`/api/users/approval-requests/${requestId}/approve`);
    return response.data;
  },

  // Reject role creation request (using general approval API)
  rejectRole: async (requestId, reason) => {
    const response = await api.put(`/api/users/approval-requests/${requestId}/reject`, { reason });
    return response.data;
  }
}; 